export default {"src":"/_next/static/media/expand.83306eef.svg","height":16,"width":16};